namespace Matrix.Data {
    export namespace BlogService {
        export const baseUrl = 'Data/Blog';

        export declare function GetPosts(request: Serenity.ServiceRequest, onSuccess?: (response: Serenity.ListResponse<BlogPost>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            GetPosts = "Data/Blog/GetPosts"
        }

        [
            'GetPosts'
        ].forEach(x => {
            (<any>BlogService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
